import MenuDetailContainer from './MenuDetailContainer';
export default MenuDetailContainer;
